<template>
    <div id="froalaEditor" :class="[clean ? 'is-clean' : '']"></div>
</template>
<script>
import FroalaEditor from 'froala-editor'
import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/js/languages/zh_cn.js';
import 'froala-editor/js/plugins.pkgd.min.js';
import 'froala-editor/js/third_party/embedly.min.js';
import 'froala-editor/js/third_party/font_awesome.min.js';
import 'froala-editor/js/third_party/spell_checker.min.js';
import 'froala-editor/js/third_party/image_tui.min.js';
import 'froala-editor/js/third_party/showdown.min.js';
export default {
    props: {
        value: {
            type: String,
            default: null
        },
        documentReady: {
            type: Boolean,
            default: false
        },
        clean: {
            type: Boolean,
            default: false
        },
        height: {
            type: Number,
            default: 200
        },
        heightMax: {
            type: Number,
            default: 500
        },
    },
    data () {
        return {
            editor: null,
        }
    },
    watch: {
        value: {
            handler(newVla, oldVal) {
                if (newVla != (this.editor?.html.get() ?? null)) {
                    this.editor?.html?.set(this.value)
                }
            },
            immediate: true
        },
    },
    mounted () {
        this.editor = new FroalaEditor('#froalaEditor', {
            zIndex: 25001,
                        documentReady: this.documentReady,
                        editInPopup: false,
                        fullPage: true,
                        iframe: true,
                        toolbarInline: false,
                        toolbarSticky: false,
                        toolbarBottom: false,
                        toolbarVisibleWithoutSelection: true,
                        toolbarStickyOffset: 0,
                        toolbarButtons: {
                moreRich: {
                    buttons: ['insertImage', 'insertVideo', 'insertLink', 'insertTable', 'emoticons', 'fontAwesome', 'specialCharacters', 'embedly', 'insertHR', 'markdown', 'trackChanges']
                },
                moreText: {
                    buttons: ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor', 'inlineClass', 'inlineStyle', 'clearFormatting']
                },
                moreParagraph: {
                    buttons: ['align', 'alignLeft', 'alignCenter', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote']
                },
                moreMisc: {
                    buttons: ['undo', 'redo', 'fullscreen', 'print', 'getPDF', 'spellChecker', 'selectAll', 'html', 'help'],
                    align: 'right',
                    buttonsVisible: 2
                }
            },
                                                                                    tabSpaces: 4,
                        charCounterCount: true,
                                                placeholderText: '请输入内容!',
                        pastePlain: false,
                                                videoResponsive: true,
                        quickInsertEnabled: false,
            quickInsertButtons: ['embedly', 'table', 'ul', 'ol', 'hr'],
            quickInsertTags: ['p', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'pre', 'blockquote'],
                        heigth: this.height,
            heightMin: this.height,
            heightMax: this.heightMax,
                        codeBeautifierOptions: {
                end_with_newline: true,
                indent_inner_html: true,
                extra_liners: "['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'pre', 'ul', 'ol', 'table', 'dl']",
                brace_style: 'expand',
                indent_char: ' ',
                indent_size: 4,
                wrap_line_length: 0
            },
            codeMirror: true,
            codeMirrorOptions: {
                indentWithTabs: true,
                lineNumbers: true,
                lineWrapping: true,
                mode: 'text/html',
                tabMode: 'indent',
                tabSize: 2
            },
            codeViewKeepActiveButtons: ["fullscreen"],
                        colorsBackground: [
                '#f44336', '#e91e63', '#9c27b0', '#673ab7', '#3f51b5', '#2196f3', '#03a9f4', '#00bcd4',
                '#009688', '#4caf50', '#8bc34a', '#cddc39', '#ffeb3b', '#ffc107', '#ff9800', '#ff5722',
                '#795548', '#9e9e9e', '#607d8b', 'REMOVE'
            ],
            colorsButtons: ["colorsBack", "|", "-"],
            colorsHEXInput: true,
            colorsStep: 8,
            colorsText: [
                '#f44336', '#e91e63', '#9c27b0', '#673ab7', '#3f51b5', '#2196f3', '#03a9f4', '#00bcd4',
                '#009688', '#4caf50', '#8bc34a', '#cddc39', '#ffeb3b', '#ffc107', '#ff9800', '#ff5722',
                '#795548', '#9e9e9e', '#607d8b', 'REMOVE'
            ],
                        dragInline: false,
                        emoticonsButtons: ["emoticonsBack", "|"],
            emoticonsUseImage: true,
            emoticonsStep: 10,
                        fontFamily: {
                'Arial,Helvetica,sans-serif': 'Arial',
                'Georgia,serif': 'Georgia',
                'Impact,Charcoal,sans-serif': 'Impact',
                'Tahoma,Geneva,sans-serif': 'Tahoma',
                "'Times New Roman',Times,serif": 'Times New Roman',
                'Verdana,Geneva,sans-serif': 'Verdana'
            },
            fontFamilyDefaultSelection: '字体',
            fontFamilySelection: true,
                        fontSizeSelection: true,
            fontSize: ['8', '9', '10', '11', '12', '14', '18', '24', '30', '36', '48', '60', '72', '96'],
            fontSizeDefaultSelection: '14',
            fontSizeUnit: 'px',
                        imageAddNewLine: true,
            imageResizeWithPercent: true,
            imageDefaultWidth: 100,
            imageUploadRemoteUrls: true,
            imageUpload: true,
            imageUploadMethod: 'POST',
            imageUploadURL: '/9api/components-files/upload-link',
                        requestHeaders: {
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            },
                        attribution: false,
            autofocus: false,
            htmlAllowComments: true,
            htmlExecuteScripts: false,
            htmlUntouched: true,
            language: 'zh_cn',
            events: {
                'contentChanged': () => {
                    this.$emit('input', this.editor.html.get())
                },
                'initialized': () => {
                    this.editor.html.set(this.value)
                }
            }
        })
    }
}
</script>

<style type="text/css">
    a[href="https://froala.com/wysiwyg-editor"], a[href="https://www.froala.com/wysiwyg-editor?k=u"] {
      display: none !important;
      position: absolute;
      top: -99999999px;
     }
</style>
